import styled from "styled-components";

import { Box, FlexDiv } from "@/components/Atoms/Box";
import Button from "@/components/Atoms/Button";

import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const QuestionWrapper = styled(FlexDiv)`
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  height: fit-content;
  @media only screen and (max-width: 600px) {
    padding: 0px 0px 24px 0px;
  }
`;

export const Question = styled(Typography)`
  color: ${theme.colorsV2.primary.shade_900};
`;

export const AnswerWrapper = styled(Box)`
  overflow: hidden;
`;

export const Answer = styled(Box)`
  div,
  p {
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    font-family: var(--man-400);
    color: ${theme.colorsV2.gray.shade_800};
  }
  strong {
    font-size: 16px;
    line-height: 24px;
    color: ${theme.colorsV2.gray.shade_800};
  }
`;

export const ShowMoreLessButton = styled(Button)`
  padding: 0;
  width: fit-content;
  p {
    color: ${theme.colorsV2.shyft.purple_text};
  }
`;
